import React, { useEffect, useRef, useState, useCallback } from 'react'
import Calendar from '../components/Calendar'
import { useTranslate } from "../components/TranslationText";
import ComingSoon from '../components/ComingSoon';
import { CalenderSeasonsCalculator } from '../helper/CalenderSeasonsCalculator';
import axios from '../axios/axios';
import { getDayfromDate } from '../helper/getDayfromDate';
import axiosUmbraco from '../axios/axiosUmbraco';
import { getEventColor } from '../helper/getEventColor';
import { Link, useLocation, useNavigationType } from 'react-router-dom';
import { getEventLink } from '../helper/getEventLink';
import Loader from '../components/Loader';
import { whiteCard } from '../common/cssclasses';
import { updateHeadTags } from '../helper/updateHeadTags';
import {
    checkIsReturning,
    setReturnTicket,
    consumeReturnTicket
} from '../helper/pageFilterPersistence';

const CAL_TICKET_KEY = "cal_return_from_details";
const CAL_ACTIVE_COLOR_KEY = "cal_activeColor";
const CAL_NOW_DATE_KEY = "cal_nowDate";

function clearCalendarSessionStorage() {
    sessionStorage.removeItem(CAL_ACTIVE_COLOR_KEY);
    sessionStorage.removeItem(CAL_NOW_DATE_KEY);
    sessionStorage.removeItem(CAL_TICKET_KEY);
}

const eventColorsID = process.env.REACT_APP_EVENTS_COLORS_ID;
const umbracoEvents = process.env.REACT_APP_UMBRACO_EVENTS_ID;
const calenderPageId = process.env.REACT_APP_HOME_PAGE_FOOTER_ID;
const baseURL = process.env.REACT_APP_UMBRACO;

export default function CalendarPage() {
    const { translate } = useTranslate()
    const navigationType = useNavigationType();
    const location = useLocation();
    const prevLocationKey = useRef(location.key);
    const isInitialMount = useRef(true);
    const wasReturningRef = useRef(false);

    if (isInitialMount.current) {
        isInitialMount.current = false;
        const isReturning = checkIsReturning(CAL_TICKET_KEY, navigationType, "calendar");
        wasReturningRef.current = isReturning;
        if (!isReturning) {
            clearCalendarSessionStorage();
        }
    }

    const [nowDate, setNowDate] = useState(() => {
        const savedDate = sessionStorage.getItem(CAL_NOW_DATE_KEY);
        if (savedDate) {
            const parsed = new Date(savedDate);
            if (!isNaN(parsed.getTime())) return parsed;
        }
        return new Date();
    });
    const [dates, setDates] = useState(CalenderSeasonsCalculator(nowDate.getFullYear()));
    const [loaded, setLoaded] = useState(false);

    const searchParams = new URLSearchParams(location.search);
    const incomingSeason = searchParams.has("season") ? searchParams.get("season") : null;






    useEffect(() => {
        setDates(CalenderSeasonsCalculator(nowDate.getFullYear()));
    }, [nowDate]);

    const [events, setEvents] = useState([]);
    const [allEvents, setAllEvents] = useState([]);
    const [eventColors, setEventsColors] = useState([]);
    const [activeColor, setActiveColor] = useState(() => {
        const saved = sessionStorage.getItem(CAL_ACTIVE_COLOR_KEY);
        return saved ? JSON.parse(saved) : [];
    });
    const activeColorRef = useRef(activeColor);
    activeColorRef.current = activeColor;
    const [eventsCountsInCurrentSeason, setEventsCountInCurrentSeason] = useState(0);

    const applyColorFilter = useCallback((colorsToApply, currentAllEvents) => {
        if (!colorsToApply || colorsToApply.length === 0) {
            return currentAllEvents;
        }
        const umbracoEventsList = currentAllEvents.filter(x => x.isFromUmbraco === true);
        const apiEventsList = currentAllEvents.filter(x => x.isFromUmbraco === false);
        const displayedUmbracoEvents = umbracoEventsList.filter(e =>
            colorsToApply.some(ac => ac?.eventName === e?.type)
        );
        const displayedApiEvents = apiEventsList.filter(e =>
            colorsToApply.some(ac => ac?.eventCode === e?.type)
        );
        return [...displayedUmbracoEvents, ...displayedApiEvents];
    }, []);

    const handleNext = () => {
        setActiveColor([]);
        sessionStorage.removeItem(CAL_ACTIVE_COLOR_KEY);
        const newDate = new Date(nowDate.getTime());
        newDate.setFullYear(nowDate.getFullYear() + 1);
        setNowDate(newDate);
        sessionStorage.setItem(CAL_NOW_DATE_KEY, newDate.toISOString());
        getseasons(dates[0].getFullYear() + 1, dates[6].getFullYear() + 1);
        setLoaded(false);
    };

    const handlePrev = () => {
        setActiveColor([]);
        sessionStorage.removeItem(CAL_ACTIVE_COLOR_KEY);
        const newDate = new Date(nowDate.getTime());
        newDate.setFullYear(nowDate.getFullYear() - 1);
        setNowDate(newDate);
        sessionStorage.setItem(CAL_NOW_DATE_KEY, newDate.toISOString());
        getseasons(dates[0].getFullYear() - 1, dates[6].getFullYear() - 1);
        setLoaded(false);
    };

    function getCurrentLanguageUmbraco(isUmbracoAPI = false) {
        const lang = localStorage.getItem("eahsLang") ?? "en";
        if (!isUmbracoAPI) {
            return lang === "en" ? 'en' : 'ar';
        } else {
            return lang === "en" ? 'en-US' : 'ar-AE';
        }
    }

    async function getLatestSeason() {
        const latestseasonis = await axios.get('shows/GetLastSeason')
        const [startDate, endDate] = latestseasonis.data.result.split("-");
        return { startDate, endDate }
    }


    async function getseasons(startDate, endDate) {
        const eventsColors = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content?fetch=children:${eventColorsID}&skip=0&take=1000`,
            {
                headers: {
                    "accept-language": getCurrentLanguageUmbraco(true),
                },
            });

        const formattedColors = eventsColors.data.items.map((item) => ({
            eventName: item?.properties?.eventName ?? '',
            eventDisplayName: item?.properties?.eventDisplayName ?? '',
            eventCode: item?.properties?.eventCode ?? '',
            eventColor: item?.properties?.eventColor ?? '',
            sort: item?.properties?.sort ?? 0,
        }));
        formattedColors.sort((a, b) => a.sort - b.sort);
        setEventsColors(formattedColors);

        const eventsFromUmbraco = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content?fetch=children:${umbracoEvents}&skip=0&take=1000`,
            {
                headers: {
                    "accept-language": getCurrentLanguageUmbraco(true),
                },
            });


        const seo = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content/item/?id=${umbracoEvents}`,);
        if (seo?.data?.length > 0) {
            const seoData = seo.data[0].properties;
            updateHeadTags({
                keywords: seoData?.seoKeywords,
                description: seoData?.seoDescription,
                title: seoData?.seoTitle,
            })
        }

        const formatedUmbracoEvents = eventsFromUmbraco.data.items.map((item) => ({
            title: item.properties.eventTitle,
            start: item.properties.eventStart,
            id: "",
            end: item.properties.eventEnd,
            type: item.properties.type,
            backgroundColor: (item?.properties?.logo != null && item?.properties?.logo?.length > 0) ? `url(${baseURL}${item?.properties?.logo[0]?.url})` : getEventColor(item.properties.type, formattedColors, true),
            eventBG: getEventColor(item.properties.type, formattedColors, true),
            isFromUmbraco: true
        }));

        const incomingEvents = await axios.get(`shows/getseasonshowandauctonsbyseason?season=${startDate}-${endDate}&Langauge=${getCurrentLanguageUmbraco(false)}`);

        const formatedEvents = incomingEvents.data.result.map((item) => ({
            title: item.title,
            id: item.id ?? '',
            start: item.start,
            end: item.end,
            type: item.type,
            backgroundColor: (item.logo != null && item.logo !== "") ? `url(${item.logo})` : getEventColor(item.type, formattedColors, false),
            eventBG: getEventColor(item.type, formattedColors, false),
            isFromUmbraco: false
        }));

        const totalEvents = [...formatedUmbracoEvents, ...formatedEvents];
        const filterdTotalEvents = totalEvents.filter((item) => {
            const myFullYear = new Date(item.start).getFullYear();
            const isbetween = (myFullYear >= startDate && myFullYear < endDate)
            return isbetween
        })


        setEventsCountInCurrentSeason(filterdTotalEvents.length);
        setLoaded(true);
        setAllEvents(totalEvents);
        const eventsToDisplay = applyColorFilter(activeColorRef.current, totalEvents);
        setEvents(eventsToDisplay);
        // Extract unique months from totalEvents' start and end dates
        const monthsSet = new Set();
        totalEvents.forEach(event => {
            if (event.start) {
                const startMonth = new Date(event.start).getMonth();
                monthsSet.add(startMonth);
            }
            if (event.end) {
                const endMonth = new Date(event.end).getMonth();
                monthsSet.add(endMonth);
            }
        });
    }

    useEffect(() => {
        async function fetchData() {
            let sDate, eDate;
            const savedNowDate = sessionStorage.getItem(CAL_NOW_DATE_KEY);
            if (incomingSeason) {
                const [startDate, endDate] = incomingSeason.split("-");
                sDate = startDate;
                eDate = endDate;
                const d = new Date(sDate, 0, 1);
                setNowDate(d);
                setDates(CalenderSeasonsCalculator(sDate));
            } else if (wasReturningRef.current && savedNowDate) {
                const parsedDate = new Date(savedNowDate);
                const sYear = parsedDate.getFullYear();
                sDate = sYear;
                eDate = sYear + 1;
                setNowDate(parsedDate);
                setDates(CalenderSeasonsCalculator(sYear));
            } else {
                const { startDate, endDate } = await getLatestSeason();
                sDate = startDate;
                eDate = endDate;
                const d = new Date(sDate, 0, 1);
                setNowDate(d);
                setDates(CalenderSeasonsCalculator(sDate));
            }
            getseasons(sDate, eDate);
        }
        fetchData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (wasReturningRef.current) {
            consumeReturnTicket(CAL_TICKET_KEY);
        }
    }, []);

    useEffect(() => {
        if (prevLocationKey.current !== location.key) {
            prevLocationKey.current = location.key;
            if (navigationType === "PUSH") {
                clearCalendarSessionStorage();
                setActiveColor([]);
                getLatestSeason().then(({ startDate, endDate }) => {
                    const freshDate = new Date(startDate, 0, 1);
                    setNowDate(freshDate);
                    setDates(CalenderSeasonsCalculator(startDate));
                    getseasons(startDate, endDate);
                });
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.key, navigationType]);

    function chooseEventsByindex(index, date) {
        return events.map(item => ({ ...item, startDate: new Date(item.start), endDate: new Date(item.end) }))
            .filter(item => ((item.startDate.getMonth() === (index + 8) % 12 && item.startDate.getFullYear() === date.getFullYear()) || (item.endDate.getMonth() === (index + 8) % 12 && item.endDate.getFullYear() === date.getFullYear())));
    }

    useEffect(() => {
        console.debug('event!!!', events);
    }, [events])


    // calender Print PDF
    const [calenderPDFUrl, setCalenderPDFUrl] = useState('');
    async function getCalenderPDFUrl() {
        try {
            const res = await axiosUmbraco.get(`/umbraco/delivery/api/v1/content/item/${calenderPageId}`,)
            setCalenderPDFUrl(res?.data?.properties?.calendarFile);
        } catch (error) {
            console.error('Error in getCalenderPDFUrl', error);
        }

    }
    useEffect(() => {
        getCalenderPDFUrl();
    }, [])

    function filterEvents(color) {
        const filterExist = activeColor.some(c => c.eventName === color.eventName);
        const newActiveColor = filterExist
            ? activeColor.filter(c => c.eventName !== color.eventName)
            : [...activeColor, color];

        // Update state with new array
        setActiveColor(newActiveColor);
        sessionStorage.setItem(CAL_ACTIVE_COLOR_KEY, JSON.stringify(newActiveColor));
        const eventsToDisplay = applyColorFilter(newActiveColor, allEvents);
        setEvents(eventsToDisplay);
    }

    return (
        <>

            {loaded ?
                <div className='pt-4 px-2 mx-auto' style={{ maxWidth: 1400 }}>
                    <div className='row rtl'>
                        <div className='col-12 text-center'>
                            <div className="calnderuttonsContainer">
                                <div className="calenderBtn rounded" title={translate('web.prev', 'Prev')} onClick={handlePrev}>
                                    <i className=" fa-solid fa-chevron-left justRotate w-unset"></i>
                                </div>
                                <div className="year fc-toolbar-title  rtl">
                                    {dates[0].getFullYear()} - {dates[6].getFullYear()}
                                </div>
                                <div className="calenderBtn rounded" title={translate('web.next', 'Next')} onClick={handleNext}>
                                    <i className=" fa-solid fa-chevron-right justRotate w-unset"></i>
                                </div>
                            </div>
                        </div>
                        <div className='calendarLegendContainer  rtl ' >
                            {eventColors.map((item, index) => (
                                <div key={index} onClick={() => filterEvents(item)} style={{ cursor: 'pointer' }} className={`legendCard me-3 border-15  p-main mb-main ${activeColor.some(c => c?.eventName === item?.eventName) ? 'bg-selected' : 'bg-white'}`}>
                                    <div className='legendCardrect me-2' style={{ background: item.eventColor }}></div>
                                    <div className='legendCardDescription'>{item.eventDisplayName}</div>
                                </div>
                            ))}
                            {!!calenderPDFUrl &&
                                <div className='legendCard border-15 bg-transparent mb-main p-0 ms-auto'>
                                    <Link title={translate('web.downloadAsPdf', 'Dowanload as PDF')} to={`${baseURL}${calenderPDFUrl}`} target='_blank' className='btn btn-outline-danger' >
                                        <i className='fa-solid fa-download w-unset' />
                                    </Link>
                                </div>
                            }
                        </div>
                    </div>

                    <div className='row rtl ' id='tabletoprint' style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'flex-start' }}>
                        {
                            dates.map((date, index) => ({
                                date,
                                events: chooseEventsByindex(index, date)
                            })).map((item, index) => {
                                // isNoEventsinSeason(item.events.length > 0, index, dates.length);
                                return (
                                    item.events.length > 0 &&
                                    <div key={index} className={'col-xl-4  col-lg-6 col-md-12 col-sm-12 mb-main'} >
                                        <div className={whiteCard}>
                                            <Calendar showHeader={false} isLeftSide={true} events={events} initialDate={item.date} aspectRatio={1} />
                                            <div className='eventsContainer'>
                                                <EventsDates events={item.events} />
                                            </div>
                                        </div>
                                    </div>
                                )
                            }

                            )
                        }

                        {eventsCountsInCurrentSeason === 0 &&
                            <div className='' style={{ margin: 'auto' }}>
                                <ComingSoon text={'web.notAvailableNow'} defaultText={'Not Available Now'} />
                            </div>
                        }

                    </div>

                </div>
                : <Loader />
            }


        </>
    );

    function EventsDates({ events }) {
        return events.sort((a, b) => (new Date(a.start) - new Date(b.start))).map((event, index) => (
            getEventLink(event.type, event.id, event.title) === "" ?
                <div key={index} className='eventRow rtl'>
                    <div className='dayContainer' style={{ background: event.eventBG }}>{getDayfromDate(event.start)}</div>
                    <div className='dayContainer' style={{ background: event.eventBG }}>{getDayfromDate(event.end)}</div>
                    {event.backgroundColor.includes('url') &&
                        <div className='dayContainer' style={{ background: event.backgroundColor ?? event.eventBG, backgroundSize: "contain", backgroundRepeat: 'no-repeat', backgroundPosition: "center", borderRadius: 0 }}></div>
                    }
                    <div className='eventName'>{event.title}</div>
                </div>
                :
                <Link
                    key={index}
                    to={getEventLink(event.type, event.id, event.title)}
                    onClick={() => setReturnTicket(CAL_TICKET_KEY)}
                    className='eventRow rtl text-dark '
                >
                    <div className='dayContainer' style={{ background: event.eventBG, }}>{getDayfromDate(event.start)}</div>
                    <div className='dayContainer' style={{ background: event.eventBG, }}>{getDayfromDate(event.end)}</div>
                    {event.backgroundColor.includes('url') ?
                        <div className='dayContainer' style={{ background: event.backgroundColor ?? event.eventBG, backgroundSize: "contain", backgroundRepeat: 'no-repeat', backgroundPosition: "center", borderRadius: 0 }}></div> :
                        <div className='dayContainer' style={{ background: '#fff', backgroundSize: "cover", backgroundPosition: "center" }}></div>
                    }
                    <div className='eventName text-decoration-underline'>{event.title}</div>
                </Link>
        ));
    }
}
